// @flow
import React, { Component } from 'react'
import styled, { css, type StyledComponent } from 'styled-components'
import { alertColor, linkColor } from './controls/colors'
import OriginalTooltip from '../components/Tooltip'
import type { Node } from 'react'

export const MenuItem: any = (((styled.div: any).attrs({
  className: 't-MenuItem'
}): any)`
  display: block;
  padding: 10px 10px;
  text-decoration: none;
  color: black;
  cursor: pointer;

  &:hover {
    background: #61b8d3;
    color: #fff;
  }
`: any)

export class Link extends Component<{ href?: string }> {
  render() {
    const commonStyles = css`
      display: inline-block;
      &:hover {
        color: ${alertColor};
        border-color: rgba(216, 0, 0, 0.5);
        span {
          border-top-color: rgba(216, 0, 0, 0.5);
          border-bottom-color: rgba(216, 0, 0, 0.5);
        }
      }
    `
    const JustLink: StyledComponent<Object, any, any> = styled.a`
      text-decoration: none;
      ${commonStyles};
    `
    const LinkLikeDiv: StyledComponent<Object, any, any> = styled.div`
      color: ${linkColor};
      user-select: none;
      cursor: pointer;
      border-bottom: 1px dashed rgba(97, 184, 211, 0.5);
      ${commonStyles};
    `
    const { href, ...otherProps } = this.props

    return href ? <JustLink {...this.props} /> : <LinkLikeDiv {...otherProps} />
  }
}

export const Table: StyledComponent<Object, any, any> = styled.table`
  margin: 25px 0;
  width: 100%;
  border-bottom: 1px solid #d1d1d1;
  border-collapse: collapse;
  border-spacing: 0;
  background-color: white;
`
export const HeaderCell: StyledComponent<Object, any, any> = styled.td`
  font-family: 'PT Sans Caption', sans-serif;
  font-size: 11px;
  color: #000;
  text-align: right;
  padding: 5px 3px;
  white-space: nowrap;
  ${({ alignLeft }: Object) => (alignLeft ? 'text-align: left' : '')};
  ${({ minimal }: Object) => (minimal ? 'width: 1%' : '')};
`
export const HeaderRow: StyledComponent<Object, any, any> = styled.tr`
  border-bottom: 1px solid #d1d1d1;
`
export class NameLink extends Component<{| href: string, children: Node |}> {
  render() {
    const Wrapper: StyledComponent<Object, any, any> = styled.div`
      position: relative;
      width: 100%;
      padding-bottom: 4px;
    `
    const StyledLink: any = ((styled.a: any).attrs({
      className: 't-NameLink offable'
    })`
      font-weight: bold;
      &:hover {
        color: ${alertColor};
        border-color: ${alertColor};
      }
    `: any)

    return (
      <Wrapper>
        <StyledLink href={this.props.href}>{this.props.children}</StyledLink>
      </Wrapper>
    )
  }
}

const shadowColor = 'rgba(0,0,0,0.07)'
const shadowRadius = '20px'
export const BodyRow: StyledComponent<Object, any, any> = styled.tr`
  &:not(:first-of-type) {
    border-top: 1px solid #d1d1d1;
  }
  ${({ topShadow, bottomShadow }: Object) =>
    bottomShadow && !topShadow ? `box-shadow: 0 16px ${shadowRadius} -17px ${shadowColor}` : ''};
  ${({ topShadow, bottomShadow }: Object) =>
    topShadow && !bottomShadow ? `box-shadow: 0 -16px ${shadowRadius} -17px ${shadowColor};` : ''};
  ${({ topShadow, bottomShadow }: Object) =>
    topShadow && bottomShadow
      ? `box-shadow: 0 16px ${shadowRadius} -17px ${shadowColor},
      0 -16px ${shadowRadius} -17px ${shadowColor};
  `
      : ''};
`
export const Cell: StyledComponent<Object, any, any> = styled.td`
  font-size: 14px;
  color: #000;
  padding: 15px 3px;
  vertical-align: middle;
  ${({ alignLeft }: Object) => (alignLeft ? 'text-align: left' : '')};
  ${({ alignRight }: Object) => (alignRight ? 'text-align: right' : '')};
`
export const FooterRow: StyledComponent<Object, any, any> = styled.tr`
  border-top: 1px solid #d1d1d1;
  font-weight: bold;
`

class StyledTooltip extends Component<{ content: Node }> {
  render() {
    const Wrapper: StyledComponent<Object, any, any> = styled.div`
      font-size: 12px;
      width: 200px;
      padding: 6px 6px;
      text-align: left;
    `
    const { content, ...props } = this.props
    return (
      <OriginalTooltip
        hasStrongShadow
        {...(props: Object)}
        content={<Wrapper className="t-TooltipContent">{content}</Wrapper>}
      />
    )
  }
}

const Tooltip: typeof OriginalTooltip = (StyledTooltip: any)

export { Tooltip }
